import bankAccounts from './bankAccounts'
import costCenters from './costCenters'
import exportLabels from './exportLabels'
import info from './info'
import menu from './menu'
import settings from './settings'
import table from './table'

export default {
    organisationId: 'Organisation {id}',
    organisationGeneral: 'Allgemein',
    organisationAddress: 'Adresse',
    organisationContactPerson: 'Kontaktperson',
    organisationSecondContactPerson: 'Zweite Kontaktperson',
    organisationLegalEntity: "Abweichender Rechtsträger",

    organisationConnections: 'Verknüpfungen',
    organisationBankAccount: 'Bankverbindung',
    organisationUsers: 'Nutzer',

    membersCount: 'Nutzer',

    name: 'Name',
    parent_organisation_id: 'Übergeordnete Organisation',
    searchParentOrganisation: 'Suche nach Name, PLZ, Ort',
    parish_number: 'Pfarrbezirksnummer',
    active: 'Aktiv',

    street: 'Straße',
    house_number: 'Hausnummer',
    zipcode: 'Postleitzahl',
    city: 'Stadt',
    country: 'Land',
    ags: 'Gemeindeschlüssel',
    contact_person_firstname: 'Vorname',
    contact_person_lastname: 'Nachname',
    contact_person_email: 'E-Mail',
    contact_person_phone: 'Telefon',
    second_contact_person_firstname: 'Vorname',
    second_contact_person_lastname: 'Nachname',
    second_contact_person_email: 'E-Mail',
    second_contact_person_phone: 'Telefon',
    organisation_id: 'Organisation',
    type: 'Organisationstyp',
    user_id: 'Nutzer',
    role_name: 'Rolle',

    exclusionReasons: 'Wir möchten die Zuwendungsmittel nicht im Abrufverfahren bewirtschaften und machen folgende Ausschlussgründe geltend:',
    statutesDocument: 'geltende Satzung/Ordnung',
    statutes_document_id: 'ID der geltenden Satzung/Ordnung',
    boardMembersList: 'Verzeichnis der Vorstandsmitglieder',
    board_members_list_id: 'ID des Verzeichnisses der Vorstandsmitglieder',
    nonprofitCertificate: 'Nachweis der Gemeinnützigkeit',
    nonprofit_certificate_id: 'ID des Nachweises der Gemeinnützigkeit',
    registrationCertificate: 'Nachweis der Eintragung ins Vereinsregister',
    registration_certificate_id: 'ID des Nachweises der Eintragung ins Vereinsregister',
    youthWelfareCertificate: 'Bescheid über die Anerkennung als Träger der Jugendhilfe nach § 75 KJHG',
    youth_welfare_certificate_id: 'ID des Bescheids über die Anerkennung als Träger der Jugendhilfe nach § 75 KJHG',
    affiliatedUnitsList: 'Bei Zentralstelle: Verzeichnis der angeschlossenen Gliederung',
    affiliated_units_list_id: 'ID des Verzeichnisses der angeschlossenen Gliederung',
    notAffiliatedInternationalMeetings: '  Für das KJP-Handlungsfeld "Internationale Begegnungen" sind wir keiner Zentralstelle (Nr. III.1 (5) RL-KJP) angeschlossen.',
    not_affiliated_international_meetings: 'Für das KJP-Handlungsfeld "Internationale Begegnungen" sind wir keiner Zentralstelle (Nr. III.1 (5) RL-KJP) angeschlossen.',
    notAffiliatedYouthAssociationWork: 'Für das KJP-Handlungsfeld "Jugendverbandsarbeit" sind wir keiner Zentralstelle (Nr. III.1 (5) RL-KJP) angeschlossen.',
    not_affiliated_youth_association_work: 'Für das KJP-Handlungsfeld "Jugendverbandsarbeit" sind wir keiner Zentralstelle (Nr. III.1 (5) RL-KJP) angeschlossen.',
    notAffiliatedPoliticalEducation: 'Für das KJP-Handlungsfeld "Politische Bildung" sind wir keiner Zentralstelle (Nr. III.1 (5) RL-KJP) angeschlossen.',
    not_affiliated_political_education: 'Für das KJP-Handlungsfeld "Politische Bildung" sind wir keiner Zentralstelle (Nr. III.1 (5) RL-KJP) angeschlossen.',
    proof_deadline_international: 'Abgabefrist für Verwendungsnachweise im Bereich Internationale Begegnungen',
    proof_deadline_youth_association: 'Abgabefrist für Verwendungsnachweise im Bereich Jugendverbandsarbeit',
    proof_deadline_political_education: 'Abgabefrist für Verwendungsnachweise im Bereich Politische Bildung',
    warning_goal_agreement_days: 'Mahnfrist für Zielvereinbarungen',
    warning_transfer_agreement_days: 'Mahnfrist für Weiterleitungsverträge',
    warning_proof_days: 'Erste Erinnerungsfrist für Verwendungsnachweise',
    second_warning_proof_days: 'Zweite Erinnerungsfrist für Verwendungsnachweise',
    third_warning_proof_days: 'Mahnfrist für Verwendungsnachweise',
    protection_concept_validity_years: 'Gültikeit von Schutzkonzepten',

    category_id: 'Kategorie Id',
    tags: 'Tags',
    creditor_number: 'P5 Kreditorennummer',

    form: {
        general: {
            name: 'Name',
            id: 'ID',
            member_id: 'Mitgliedsnummer',
            member_id_info: 'Falls keine Mitgliedsnummer angegeben wird, übernimmt die Organisation automatisch die Mitgliedsnummer der übergeordneten Organisation.',
            parentOrganisation: 'Übergeordnete Organisation',
            noParentOrganisation: 'Keine übergeordnete Organisation',
            searchParentOrganisation: 'Suche nach Name, PLZ, Ort',
            type: 'Organisationstyp',
            types: {
                organisation: 'Standardorganisation',
                association: 'Verband',
            },
            creditor_number: 'P5 Kreditorennummer',
            parishNumber: 'Pfarrbezirksnummer',
            active: 'Aktiv',
            auth_code: 'Authentifizierungscode',
        },

        legal_entity: {
            name: 'Name',
            email: 'E-Mail',
            phone: 'Telefon',
        },

        address: {
            street: 'Straße',
            houseNumber: 'Hausnummer',
            zipcode: 'Postleitzahl',
            city: 'Stadt',
            country: 'Land',
            foreignAddress: 'Ausländische Adresse',
            ags: 'Gemeindeschlüssel',
            agsAutoFilled: 'Der Gemeindeschlüssel wird automatisch generiert.'
        },

        contactPerson: {
            firstname: 'Vorname',
            lastname: 'Nachname',
            email: 'E-Mail',
            phone: 'Telefon'
        },
        secondContactPerson: {
            firstname: 'Vorname',
            lastname: 'Nachname',
            email: 'E-Mail',
            phone: 'Telefon'
        },
    },

    saveSuccess: 'Organisation wurde erfolgreich gespeichert.',

    deleteOrganisation: 'Organisation löschen',
    deleteOrganisationText:
        'Möchten Sie die Organisation wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteOrganisationSuccess: 'Organisation wurde erfolgreich gelöscht.',
    deleteOrganisationError: 'Die Organisation konnte nicht gelöscht werden.',
    transferOrDeleteUsers: 'Die Nutzer der Organisation können entweder gelöscht oder einer anderen Organisation zugewiesen werden.',
    selectOrganisation: 'Wählen Sie eine Organisation',
    cantDeleteCurrentOrganisation: 'Sie können Ihre aktive Organisation nicht löschen.',
    cantDeleteOrganisationWithChildren: 'Die Organisation kann nicht gelöscht werden, da sie noch untergeordnete Organisationen hat.',

    toggleState: 'aktivieren / deaktivieren',
    toggleStateSuccess: 'Status wurde erfolgreich geändert.',
    toggleStateError: 'Der Status konnte nicht geändert werden.',

    print: {
        noDocumentCouldBeExported: 'Es konnte kein Dokument zur Ansicht gefunden oder erzeugt werden.',
        exportError: 'Fehlende Vorlage',
    },

    bankAccounts,
    costCenters,
    exportLabels,
    info,
    menu,
    settings,
    table,
}